import React, { useState, useEffect } from "react";
import useCustomMutation from "../../../../../../Hooks/useCustomMutation";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "reactstrap";
import ButtonSubmit from "../../../../../Buttons/ButtonSubmit";
import excelFile from "../../../../../../assets/participants/Attendee.xlsx";

import "./bulk-attendee.styles.scss";

const BulkAttendee = ({ userID, token, eventID, setIsOffcanvasOpen }) => {
  const key = ["myAttendees", eventID];
  const mutation = useCustomMutation(key);
  const [isAttachmentDocument, setIsAttachmentDocument] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const handleSubmitBulk = (event) => {
    event.preventDefault();
    const Method = "POST",
      url = `attendees/bulk-add/${eventID}`,
      isJSON = true;
    var formdata = new FormData();
    formdata.append("document", isAttachmentDocument[0]);

    const data = {
      endPoint: url,
      bodyContent: formdata,
      Method: Method,
      displayMessage: "User successfully invited",
      token: token,
      isJSON: isJSON,
    };
    mutation.mutate(data);
  };

  useEffect(() => {
    if (mutation?.isSuccess) {
      setIsAttachmentDocument([]);
      setIsOffcanvasOpen(false);
    }
  }, [mutation?.isSuccess]);

  //attach document function
  const handleAttachment = (event) => {
    const selectedFiles = event.target.files;
    const fileArray = Array.from(selectedFiles);
    setIsAttachmentDocument(fileArray);

    const previews = fileArray.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
  };

  //define file icon
  const getFileIcon = (fileName) => {
    if (fileName.endsWith(".xls") || fileName.endsWith(".xlsx")) {
      return "far fa-file-excel";
    } else {
      return "far fa-file";
    }
  };

  return (
    <React.Fragment>
      <div className="bulk-attendee__heading">
        <p
          className="bulk-attendee__heading--header"
          style={{ fontWeight: "600" }}
        >
          Upload the list of attendees
        </p>
        <p className="bulk-attendee__heading--description">
          You can use the attached template as a guide. Please fill out all
          required fields to avoid issues after submitting attendee information.
          Keep in mind that csv uploads are limited to 5000 rows and 1MB in
          size.
        </p>
        <div className="mb-3">
          <a href={excelFile} download="Attendee.xlsx">
            <Button className="btn bg-primary">Download This Template</Button>
          </a>
        </div>
      </div>

      <form
        noValidate
        data-testid="form"
        // className="single-attendee__body--form"
        onSubmit={handleSubmitBulk}
      >
        <div className="mt-0">
          {/* ------------------ Form Fields ---------------------- */}

          <div className="booth__body--form-input-container">
            <p className="input-heading">Upload file* </p>
            <div className="file-previews-doc">
              {isAttachmentDocument?.map((document, index) => {
                // console.log("imagePreviews...", imagePreviews);
                return (
                  <div key={index} className="file-preview-doc">
                    <i
                      className={`${getFileIcon(document.name)} file-icon-doc`}
                    ></i>
                    <div className="file-details-doc">
                      <div className="file-name-doc">{document.name}</div>
                      <div className="file-size-doc">
                        {(document.size / 1024).toFixed(2)} KB
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="mb-1 drop-zone">
              <label htmlFor="attachment" className="drop-zone-label">
                <i className="fas fa-cloud-upload-alt"></i>
                <div className="drop-zone-text">Attach file(s)</div>
              </label>
              <input
                type="file"
                id="attachment"
                className="form-control drop-zone-input"
                // accept=".pdf, .xls, .xlsx, .doc, .docx,image/*"
                accept=".xlsx,.xls,"
                onChange={handleAttachment}
              />
            </div>
            <div style={{ marginRight: "12px" }}>
              <p color="ambience.6">
                <span className="h6">Recommended format: </span>
                Excel | Up to 5 MB
              </p>
            </div>
          </div>
        </div>
        <div className="w-100 d-flex justify-content-center">
          <ButtonSubmit
            Title="Submit"
            BackgroundColor="#f68a20"
            ColorText="white"
            BorderColor="#f68a20"
            borderRadius={20}
            handleOnclick={handleSubmitBulk}
            pending={mutation?.isLoading}
          />
        </div>
        {/* <div className="next-container" style={{ marginTop: "16px" }}>
          <button className="" type="submit">
            <div className="d-flex justify-content-center align-items-center text-light">

              {!mutation.isLoading ? <span>Submit</span> : null}
              {!mutation.isLoading ? null : (
                <span>
                  <Spinner as="span" animation="border" size="sm" /> Loading
                </span>
              )}
            </div>
          </button>
        </div> */}
      </form>
    </React.Fragment>
  );
};
export default BulkAttendee;
